import { render, staticRenderFns } from "./taxPersonEquityList.vue?vue&type=template&id=1c3a36e6&scoped=true&"
import script from "./taxPersonEquityList.vue?vue&type=script&lang=js&"
export * from "./taxPersonEquityList.vue?vue&type=script&lang=js&"
import style0 from "./taxPersonEquityList.vue?vue&type=style&index=0&id=1c3a36e6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a36e6",
  null
  
)

export default component.exports